import React, { Component } from 'react';

class OpSelect extends Component {

  render() {

    return (
      <React.Fragment>
        <div className="btn-group flex-wrap">
          {this.props.groups.map((e) => (
            <div className="btn" key={e.groupe}
              style={{
                backgroundColor: e.active == true ? this.props.properties.find((f) => f.groupe == e.groupe) ? this.props.properties.find((f) => f.groupe == e.groupe).color : "white" : "white",
                color: e.active == true ? "white" : "black",
                borderColor: this.props.properties.find((f) => f.groupe == e.groupe) ? this.props.properties.find((f) => f.groupe == e.groupe).color : "white"
              }}
              onClick={this.props.handleToggle}>
              {e.groupe}
            </div>
          ))}
        </div>
      </React.Fragment >
    );
  }
}

export default OpSelect;